import React from 'react';
import { Input, Button, Link, Text } from '../../../ui-kit';

import '../styles/_login-modal.scss';










export default function LoginForm({
  onCancel,
  handleLogin,
  updateEmail,
  updatePassword,
  busy,
  error
}) {
  return (
    <>
      <div className="login-modal__body">
        <Input
          label="Email"
          labelProps={{ required: true }}
          className="login-modal__input"
          onChange={updateEmail}
          placeholder="Enter email" />

        <Input
          label="Password"
          labelProps={{ required: true }}
          type="password"
          className="login-modal__input"
          onChange={updatePassword}
          placeholder="Enter password" />

        <hr />
        <Text label>
          {'Don\'t forget, you can invite others to collaborate and join you on your video' +
          ' production journey.'}
        </Text>
        <Button className="login-modal__button" onClick={handleLogin} busy={busy}>
          Login
        </Button>
        <Link className="login-modal__cancel-button" onClick={onCancel}>
          Go Back
        </Link>
      </div>
      {error ?
      <Text danger prefixIcon="alert" prefixIconColor="redApple">Something went wrong</Text> :
      null}

    </>);

}